import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '@flipto/shared/src/lib/utils/common/time/date-utils';

@Pipe({
    name: 'isDateInList',
    standalone: false
})
export class IsDateInListPipe implements PipeTransform {
    constructor() {
    }

    transform(date: Date, list: Date[]): boolean {
        if (date && list?.length) {
            return !!list.find(d => DateUtils.isSame(d, date));
        }
        return false;
    }
}
